<template>
  <transition name="slide">
    <div id="popup" v-if="visible">
      <div class="container" style="display: flex;justify-content: center;max-width: 700px">
        <div class="row">
          <div class="col-xs-12">
            <a href="#" class="close-popup"
               v-if="negativeButton"
               @click="emitResponse(false)"><img alt="X" src="@/img/schliessen_button_weiss.png"></a>
            <span v-if="title" class="popup-title">{{ title }}</span>
            <div class="popup-inner">
              <p v-if="bodyText" class="popup-text">{{ bodyText }}</p>
              <slot/>
            </div>
          </div>
          <div v-if="negativeButton" class="col-xs-6">
            <button class="negative-btn" @click="emitResponse(false)">{{ negativeButton }}</button>
          </div>
          <div class="col-xs-6" :class="{
						'col-xs-offset-6': !negativeButton,
					}">
            <button class="positive-btn" @click="emitResponse(true)">{{ positiveButton }}</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  props: {
    title: String,
    bodyText: String,
    visible: Boolean,
    positiveButton: {
      type: String,
      default: "OK"
    },
    negativeButton: {
      type: String,
      default: ""
    },
  },
  methods: {
    emitResponse(positiv) {
      this.$emit(positiv ? 'positive-response' : 'negative-response')
    }
  }
}
</script>
